import "../style.css";

function UpperTextLeftAnchor({ text, text2, posx, posy, fontSize, textColor = "white" }) {
  return (
    <div
      className="container-component-upper-text-left-anchor"
      style={{ top: `${posy}%`, left: `${posx}%`, position: "absolute", zIndex: 1000 }}
    >
      <span className="unit" style={{ fontSize: fontSize, color: textColor }}>
        {text}
      </span>
      <br />
      <span className="unit" style={{ fontSize: fontSize, color: textColor }}>
        {text2}
      </span>
    </div>
  );
}

export default UpperTextLeftAnchor;
